/**
 * Utility function to perform file download.
 * Basic url checks will be performed to ensure the link is https and valid.
 *
 * @param url - The URL of the file to be downloaded.
 */
export const performFileDownload = (url: string) => {
  try {
    if (!url.startsWith("https") || !new URL(url)) return;

    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.rel = "noreferrer noopener";
    link.click();
  } catch {
    return;
  }
};
